import Icon from '@mdi/react'
import styled from 'styled-components'

import theme from 'theme_'

const { colors, spacing, devices } = theme

export const StyledCompaniesPage = styled.section`
  padding: ${spacing.xxl} ${spacing.s};

  @media ${devices.tablet} {
    padding: ${spacing.xxl} ${spacing.lg};
  }
`

export const CompaniesItemsList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${spacing.xs};
  margin-top: ${spacing.xxxl};

  @media ${devices.tablet} {
    flex-direction: row;
    gap: ${spacing.base};
  }
`

export const CompaniesItemBtn = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 96px;
  padding: ${theme.spacing.sm};
  border: 1px solid
    ${(p) => (p.$isActive ? colors.horizonOrange : 'transparent')};
  border-radius: 8px;
  background-color: ${(p) => (p.$isActive ? colors.hover10 : colors.white)};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  cursor: pointer;
  transition: all 0.2s;

  @media ${devices.tablet} {
    width: calc(50% - 8px);
  }

  @media ${devices.desktop} {
    &:hover {
      background-color: ${colors.hover10};
      border-color: ${colors.horizonOrange};
    }
    width: calc(33.33% - 16px);
  }

  @media ${devices.mediumDesktop} {
    width: calc(25% - 16px);
  }
`

export const CompaniesItemMeta = styled.div`
  display: flex;
  align-items: center;
`

export const CompaniesCurrentIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const CompaniesMetaName = styled.div`
  margin-left: ${spacing.base};
  font-weight: 700;
`
